import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useTrackingState } from 'contexts/TrackingProvider';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';
import axios from 'axios';
import fileDownload from 'js-file-download';

export const useFileDownload = () => {
  const { tracker } = useTrackingState();
  const { isApp } = useClient();

  return useCallback(
    async (url: string) => {
      tracker.track(TrackingEventType.FileDownload, { url });

      if (isApp) {
        DirittoAppBridge.fileDownload({ url });
      } else {
        const fileName = `diritto_fancy_share_${url.split(/(\\|\/)/g).pop()}`;
        const res = await axios.get(url, { responseType: 'blob' });
        await fileDownload(res.data, fileName);
      }
    },
    [isApp, tracker],
  );
};
